module.exports = __webpack_public_path__ + "3a86a248f67da04f35bcea5861e4ae96.mp4";